import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-profile-icon',
  templateUrl: './profile.svg',
  styleUrls: ['./profile-icon.component.scss'],
})
export class ProfileIconComponent implements OnInit {
  @Input() fillColor = 'white';

  constructor() { }

  ngOnInit() {}

}
